import React from 'react';
import Tooltip from '@atlaskit/tooltip';
export const OrderNowButtonWrapper = ({
  children,
  isAnyProductLeftUnchanged,
  isCustomerSelected,
  isLatestBillEstimateFetched,
}: {
  children: JSX.Element;
  isAnyProductLeftUnchanged: boolean;
  isCustomerSelected: boolean;
  isLatestBillEstimateFetched: boolean;
}) => {
  let tooltipContent = '';

  if (isAnyProductLeftUnchanged && !isLatestBillEstimateFetched) {
    tooltipContent = 'Before ordering, make changes to outstanding items and refresh the recurring estimate';
  } else if (isCustomerSelected && !isLatestBillEstimateFetched) {
    tooltipContent = 'Before ordering, refresh the recurring estimate';
  } else if (isAnyProductLeftUnchanged) {
    tooltipContent = 'Before ordering, make changes to outstanding items';
  } else if (!isCustomerSelected) {
    tooltipContent = 'Select a customer.';
  }

  if (tooltipContent) {
    const content: React.ReactNode = <div className="pv-12">{tooltipContent}</div>;
    return (
      <Tooltip content={content} tag="span">
        {children}
      </Tooltip>
    );
  }

  return <>{children}</>;
};
